module.exports = __webpack_public_path__ + "static/media/summit-face-tip-4.6a07402b.svg";